export enum ActionTypes {
    INQUIRY_NEWSTORE = 'INQUIRY_NEWSTORE',
    INQUIRY_RECOMMEND = 'INQUIRY_RECOMMEND',
}
